export const camelToSnakeCase = (string: string) =>
  string
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .toLowerCase();

export const snakeToCamelCase = (string: string): string => {
  return string.replace(/(^__|(?<!^)_)(.)/g, (match, leadingOrInner, letter) =>
    leadingOrInner === "__" ? match : letter.toUpperCase()
  );
};

export const isEmpty = (value: string | null | undefined) => {
  return !value || !String(value).trim();
};

export const applyNameOrder = <T>(firstName: T, lastName: T, isReversedNameOrder: boolean): [T, T] =>
  isReversedNameOrder ? [lastName, firstName] : [firstName, lastName];

export const formatFullName = (firstName: string, lastName: string, isReversedNameOrder: boolean): string =>
  applyNameOrder(firstName, lastName, isReversedNameOrder).join(" ").trim();

type TemplateValue = string | number;

export const interpolateCopy = (template: string, values: Record<string, TemplateValue>) =>
  template.replace(/{(\w+)}/g, (match, key: string) => {
    if (!(key in values)) {
      return match;
    }

    return String(values[key] ?? "");
  });
